export default __webpack_public_path__ + "media/images/svg/menu-burger-opened.svg";